import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import vuetify from './plugins/vuetify';
import ImageUploader from 'vue-image-upload-resize';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import VueResource from 'vue-resource';
import FlagIcon from 'vue-flag-icon'
//import algoliasearch from 'algoliasearch'

Vue.config.productionTip = false;

Vue.use(ImageUploader);
Vue.use(Cropper);
Vue.use(VueResource);
Vue.use(FlagIcon);
//Vue.use(algoliasearch);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
